var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const prefix = "EMERGENCY_SHUTDOWN";
const createActionTypes = (resource) => ({
  LOAD: `${prefix}/${resource}/LOAD'`,
  LOADING: `${prefix}/${resource}/LOADING'`,
  LOADED: `${prefix}/${resource}/LOADED'`
});
const stopExperimentActionTypes = createActionTypes("EXPERIMENT_STOP");
const emergencyStopExperiment = (experimentId) => {
  return {
    type: stopExperimentActionTypes.LOAD,
    payload: { experimentId }
  };
};
const emergencyStopExperimentLoading = (payload) => {
  return {
    type: stopExperimentActionTypes.LOADING,
    payload
  };
};
const emergencyStopExperimentLoaded = (payload, result) => {
  return {
    type: stopExperimentActionTypes.LOADED,
    payload: __spreadProps(__spreadValues({}, payload), { result })
  };
};
export {
  createActionTypes,
  emergencyStopExperiment,
  emergencyStopExperimentLoaded,
  emergencyStopExperimentLoading,
  stopExperimentActionTypes
};
//# sourceMappingURL=Shutdown.ducks.js.map
